import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './ProjectGallery.css';

export default class ProjectGallery extends Component {
  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
    document.body.style.overflow = '';
  }

  handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      this.props.onClose();
    } else if (e.key === 'ArrowLeft') {
      this.navigate(-1);
    } else if (e.key === 'ArrowRight') {
      this.navigate(1);
    }
  };

  navigate = (direction) => {
    const { media, index, onNavigate } = this.props;
    const next = (index + direction + media.length) % media.length;
    onNavigate(next);
  };

  handleBackdropClick = (e) => {
    if (e.target.classList.contains('gallery-overlay') || e.target.classList.contains('gallery-content')) {
      this.props.onClose();
    }
  };

  renderMainMedia(item) {
    if (item.type === 'youtube') {
      return (
        <iframe
          key={item.youtubeId}
          className="gallery-main-video"
          src={`https://www.youtube.com/embed/${item.youtubeId}?autoplay=1&rel=0`}
          title="YouTube video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      );
    }
    if (item.type === 'video') {
      return (
        <video
          key={item.mp4}
          className="gallery-main-video"
          autoPlay
          controls
          playsInline
        >
          {item.webm && <source src={item.webm} type="video/webm" />}
          <source src={item.mp4} type="video/mp4" />
        </video>
      );
    }
    return (
      <img
        key={item.src}
        className="gallery-main-image"
        src={item.src}
        alt=""
      />
    );
  }

  renderStripThumb(item, i) {
    const { index, onNavigate } = this.props;
    const isActive = i === index;

    return (
      <button
        key={i}
        className={`gallery-strip-item${isActive ? ' gallery-strip-active' : ''}`}
        onClick={() => onNavigate(i)}
      >
        {item.type === 'image' ? (
          <img src={item.src} alt="" />
        ) : item.type === 'youtube' ? (
          <img src={`https://img.youtube.com/vi/${item.youtubeId}/mqdefault.jpg`} alt="" />
        ) : (
          <div className="gallery-strip-video-icon">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        )}
      </button>
    );
  }

  render() {
    const { media, index } = this.props;
    const current = media[index];
    const hasMultiple = media.length > 1;

    return ReactDOM.createPortal(
      <div className="gallery-overlay" onClick={this.handleBackdropClick}>
        <button className="gallery-close" onClick={this.props.onClose} aria-label="Close gallery">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <div className="gallery-content">
          {hasMultiple && (
            <button className="gallery-nav gallery-nav-prev" onClick={() => this.navigate(-1)} aria-label="Previous">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </button>
          )}

          <div className="gallery-main" onClick={(e) => e.stopPropagation()}>
            {this.renderMainMedia(current)}
          </div>

          {hasMultiple && (
            <button className="gallery-nav gallery-nav-next" onClick={() => this.navigate(1)} aria-label="Next">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
          )}
        </div>

        {hasMultiple && (
          <div className="gallery-strip" onClick={(e) => e.stopPropagation()}>
            {media.map((item, i) => this.renderStripThumb(item, i))}
          </div>
        )}

        {hasMultiple && (
          <div className="gallery-counter">
            {index + 1} / {media.length}
          </div>
        )}
      </div>,
      document.body
    );
  }
}
